module.exports = __webpack_public_path__ + "media/src/assets/logo-1-7398bcb3c92d5b678a89320693f87ce5.png";